import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SidebarLink, linkCss } from './SidebarLink';

interface Props {
  items: Array<{
    name: string;
    url: string;
    active: boolean;
  }>;
  handleLogout?: () => void;
  withoutLogout?: boolean;
  user?: any;
}

function Sidebar({ items, handleLogout, withoutLogout, user }: Props) {
  const articlesComponent =
    items &&
    items.map((s, i) => {
      return (
        <SidebarLink url={s.url} key={i} title={s.name} active={s.active} />
      );
    });

  return (
    <Wrapper>
      <SitemapWrapper>
        {articlesComponent}
        {!withoutLogout && (
          <LogoutButton onClick={handleLogout}>{'Odhlásiť sa'}</LogoutButton>
        )}
        {user ? (
          <UserInvoiceInformationWrapper>
            {__('Informácie o záväzkoch:')}
            <UserInformationRow>
              <p>{__('Kredit: ')}</p>
              <p>{user.credit ? `${user.credit} €` : '0 €'}</p>
            </UserInformationRow>
            <UserInformationRow>
              {user.payment_term ? (
                <>
                  <p>{__('Splatnosť: ')}</p>
                  <p>{`${
                    user.payment_term ? `${user.payment_term} dní` : ''
                  }`}</p>
                </>
              ) : null}
            </UserInformationRow>
            <UserInformationRow>
              <p style={{ maxWidth: '70%' }}>{__('Neuhradené faktúry: ')}</p>
              <p>{`${
                user.unpaid_invoices ? `${user.unpaid_invoices} €` : '0 €'
              }`}</p>
            </UserInformationRow>
            <UserInformationRow>
              <p style={{ maxWidth: '70%' }}>
                {__('Neuhradené faktúry po splatnosti: ')}
              </p>
              <p>{`${
                user.unpaid_invoices_expired
                  ? `${user.unpaid_invoices_expired} €`
                  : '0 €'
              }`}</p>
            </UserInformationRow>
          </UserInvoiceInformationWrapper>
        ) : null}
      </SitemapWrapper>
    </Wrapper>
  );
}

const SitemapWrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(324)};
  overflow-y: auto;

  @media only screen and (max-width: 1020px) {
    white-space: nowrap;
    flex-flow: row;
    margin: 0;
    padding: ${rem(24)} 0;
    max-width: 100%;
    border-bottom: ${({ theme }) => theme.borders.primary};
    padding: ${rem(24)} ${rem(16)};
    margin: 0 auto;
    width: 100%;
  }
`;

const UserInvoiceInformationWrapper = styled(FlexCol)`
  width: 100%;
  max-width: 100%;
  overflow-y: auto;
  padding: 20px 0px;
  color: #444444;
  margin-top: 24px;
  border-top: 2px solid rgba(49, 39, 131, 0.5);
  border-bottom: 2px solid rgba(49, 39, 131, 0.5);

  @media only screen and (max-width: 1020px) {
    display: none;
  }
`;

const UserInformationRow = styled.div`
  color: #444444;
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;

  @media only screen and (max-width: 1020px) {
    p {
      margin-bottom: ${rem(16)};
      margin-top: ${rem(0)};
    }
  }
`;

const Wrapper = styled.div`
  margin-right: ${rem(36)};
  min-width: ${rem(200)};

  @media only screen and (max-width: 1020px) {
    margin-right: -${rem(16)};
    margin-left: -${rem(16)};
    margin-bottom: ${rem(16)};
    max-width: 100%;
  }
`;

const LogoutButton = styled.span`
  ${linkCss};
  cursor: pointer;
`;

export { Sidebar };
